import React, { useEffect, useRef, useState } from 'react'
import { Search, X, Check } from 'lucide-react'
import { useDispatch } from 'react-redux' 
import { translations } from '../../utils/constants'
import { setOrgSelectionCount } from '../../Redux/actions/organizationActions' 

// Which per-organization total to show under each name, by the page that
// opened the filter (searchType): the field on the organization row and the
// translation key of its label.
const COUNT_BY_PAGE = {
    vehicles: { field: 'total_vehicles', label: 'vehicles' },
    devices: { field: 'total_devices', label: 'devices' },
    users: { field: 'total_user', label: 'users' },
    gtfs: { field: 'total_gtfs', label: 'gtfsFeeds' },
    // Parking pages (the "SearchOrganizationsParking" export resolves to this
    // same component).
    parking: { field: 'total_parking_sessions', label: 'parkingSessions' },
    cameras: { field: 'total_camera_mappings', label: 'cameraMappings' },
    lots: { field: 'total_parking_lots', label: 'parkinglotsHeading' },
}

const SearchOrganizationsParking = ({ selectedOrganizations, handleOrganizationChange, organizations, setSearchModal, searchModal, language, selectedFilter, searchType }) => {
    const countMeta = COUNT_BY_PAGE[searchType] || null
    const [searchQuery, setSearchQuery] = useState('')
    const [selectedOrgs, setSelectedOrgs] = useState(selectedOrganizations || [])
    const modalRef = useRef(null)
    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(setOrgSelectionCount(selectedOrgs?.length || 0))
    }, [selectedOrgs, dispatch])

    // useEffect(() => {
    //     if (!searchModal) {
    //         setSearchQuery('')
    //         setSelectedOrgs([])

    //         if (selectedOrgs?.length > 0) {
    //             handleOrganizationChange([])
    //         }
    //     }
    // }, [searchModal])

    useEffect(() => {
        if (!searchModal) {
            setSearchQuery('')
        }
    }, [searchModal])

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                setSearchModal(false)
            }
        }

        if (searchModal) {
            document.addEventListener('mousedown', handleClickOutside)
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside)
        }
    }, [searchModal, setSearchModal])


    const filteredOrgs = organizations?.filter((org) =>
        org.organization_name?.toLowerCase()?.includes(searchQuery.toLowerCase())
    )

    const handleOrgSelection = (orgId) => {
        const isSelected = selectedOrgs?.includes(orgId)
        let updatedOrgs
        if (isSelected) {
            updatedOrgs = selectedOrgs?.filter(id => id !== orgId)
        } else {
            updatedOrgs = [...selectedOrgs, orgId]
        }
        setSelectedOrgs(updatedOrgs)
        handleOrganizationChange(updatedOrgs)
    }

    const handleSelectAll = () => {
        if (selectedOrgs.length > 1) {
            setSelectedOrgs([]);
            handleOrganizationChange([]);
        }
        else {
            const allOrgIds = organizations?.map(org => org?.id);
            setSelectedOrgs(allOrgIds);
            handleOrganizationChange(allOrgIds);
        }
    }

    const onSearchChange = (event) => {
        setSearchQuery(event.target.value)
    }

    const closeOrg = () => {
        setSearchModal(false)
    }

    return (
        <div className='search-organization-container' ref={modalRef}>
            <span className='close-icon-search' onClick={closeOrg} ><X /></span>
            <div className='search-organization-header'>
                <h1>{translations[language]?.organizations}</h1>
            </div>

            <div className='search-inner-div search-input-div2' style={{ margin: '0px' }}>
                <Search className='search-icon' />
                <input
                    type='text'
                    placeholder={translations[language]?.searchOrganizations}
                    value={searchQuery}
                    onChange={onSearchChange}
                    className='search-input'
                />
            </div>

            <div className='organizations-header'>
                <div className='organization-search-text'>{translations[language]?.organizations}</div>
                <div onClick={handleSelectAll} className='select-all-button'>
                    {selectedOrgs?.length > 1 ? `${translations[language]?.clearAll}` : `${translations[language]?.selectAll}`}
                </div>
            </div>
            <div className='organizations-list-div'>
                <div className='organizations-list'>
                    {filteredOrgs?.map((org) => (
                        <div
                            key={org.id}
                            onClick={() => handleOrgSelection(org.id)}
                            className={`organization-item ${selectedOrgs.includes(org.id) ? 'selected' : ''}`}
                        >
                            <div className='checkbox'>
                                {selectedFilter?.includes(org.id) && <Check className='check-icon' />}

                            </div>
                            <div className='organization-info'>
                                <img src={org?.logo} alt={org?.organization_name} className='organization-logo' />

                                <div className='organization-text'>
                                    <div className='organization-name capitalized-name text-ellipsis'>{org?.organization_name}</div>
                                    {countMeta && (
                                        <div className='organization-count'>
                                            <span className='organization-count-number'>
                                                {Number(org?.[countMeta.field] ?? 0)}
                                            </span>
                                            {' '}
                                            {translations[language]?.[countMeta.label]}
                                        </div>
                                    )}
                                </div>

                            </div>

                        </div>
                    ))}
                </div>
                {filteredOrgs?.length === 0 && <div className='no-results'>
                    {translations[language]?.noOrganizationsFound}
                </div>}
            </div>
        </div>
    )
}

export default SearchOrganizationsParking